package pwgs.dtos

import kotlinx.serialization.Serializable


@Serializable
enum class EUserLevel {
    Owner
}